let prefix = '/api/plants';

function getPlants() {
    return window.axios.get(prefix);
}

export default {
    getPlants
    
}